import EtablissementLicenceStatus from '@/generated/controls/etablissement/EtablissementLicenceStatus.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: EtablissementLicenceStatus
})
